import { GetGroupByIdUseCaseInterface } from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useLegends } from 'presentation/app/hooks/useLegends';
import { useService } from 'presentation/app/hooks/useService';
import { useAppSelector } from 'presentation/config/hooks/useRedux';
import {
  clearSelectedGroupData,
  loadSelectedGroupData,
} from 'presentation/config/store/groups/group-settings-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { GroupSettingsTabIds } from '../models/group-settings-tab-ids';

export const useGroupSettings = () => {
  // Hooks
  const { groupService } = useService();
  const { id: groupId } = useParams();
  const navigate = useNavigate();
  const { getLegends } = useLegends();
  const dispatch = useDispatch();

  // States
  const [activeTab, setActiveTab] =
    useState<GroupSettingsTabIds>('coordinators');
  const { selectedGroupData } = useAppSelector((state) => state.groupSettings);

  // Methods
  const requestGetGroupById = useCallback(
    async (params: GetGroupByIdUseCaseInterface.Params) => {
      await groupService
        .getGroupById(params)
        .then((res) => dispatch(loadSelectedGroupData(res)))
        .catch((err) => {
          dispatch(clearSelectedGroupData());
          notifyError(err.message);
          navigate('/grupos');
        });
    },
    [],
  );

  return {
    // States
    groupId,
    activeTab,
    selectedGroupData,
    // Methods
    navigate,
    getLegends,
    setActiveTab,
    requestGetGroupById,
  };
};
